import { System, Entity } from "ecsy";
import Disposable from "../util/disposable";

export default class DisposableSystem<T> extends System implements Disposable {
  dispose() {}
  queries!: Query<T>;
}

type Query<T> = { [K in keyof T]: QueryValue };
interface QueryValue {
  results: Entity[];
}
